const RECENT_PROJECTS_KEY = 'gramotaPress.recentProjects';
const FAVORITE_PROJECTS_KEY = 'gramotaPress.favoriteProjects';
const RECENT_LIMIT = 8;

function canUseStorage() {
    try {
        return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
    } catch (e) {
        return false;
    }
}

function readList(key) {
    if (!canUseStorage()) {
        return [];
    }

    try {
        const value = window.localStorage.getItem(key);
        const parsed = value ? JSON.parse(value) : [];
        return Array.isArray(parsed) ? parsed.filter(item => item && item.id) : [];
    } catch (e) {
        try {
            window.localStorage.removeItem(key);
        } catch (storageError) {
            // Ignore blocked storage access and keep the interface usable.
        }
        return [];
    }
}

function writeList(key, list) {
    if (!canUseStorage()) {
        return;
    }

    try {
        window.localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {
        // localStorage can be unavailable in private mode or blocked by browser settings.
    }
}

function projectSnapshot(project) {
    if (!project || !project.id) {
        return null;
    }

    return {
        id: project.id,
        name: project.name || 'Без названия',
        updated_at: project.updated_at || null,
        folder_id: project.folder_id || null
    };
}

function upsertProject(key, project, limit = null) {
    const snapshot = projectSnapshot(project);
    if (!snapshot) {
        return readList(key);
    }

    const list = readList(key).filter(item => String(item.id) !== String(snapshot.id));
    const nextList = [snapshot, ...list];
    const limitedList = limit ? nextList.slice(0, limit) : nextList;
    writeList(key, limitedList);

    return limitedList;
}

export default {
    recentLimit: RECENT_LIMIT,

    getRecentProjects() {
        return readList(RECENT_PROJECTS_KEY).slice(0, RECENT_LIMIT);
    },

    addRecentProject(project) {
        return upsertProject(RECENT_PROJECTS_KEY, project, RECENT_LIMIT);
    },

    getFavoriteProjects() {
        return readList(FAVORITE_PROJECTS_KEY);
    },

    isFavoriteProject(projectId) {
        return readList(FAVORITE_PROJECTS_KEY)
            .some(item => String(item.id) === String(projectId));
    },

    addFavoriteProject(project) {
        return upsertProject(FAVORITE_PROJECTS_KEY, project);
    },

    removeFavoriteProject(projectId) {
        const nextList = readList(FAVORITE_PROJECTS_KEY)
            .filter(item => String(item.id) !== String(projectId));
        writeList(FAVORITE_PROJECTS_KEY, nextList);

        return nextList;
    }
};
